import React from 'react';

import { useSliderState } from './context';

const SliderItem = ({ Component }) => {
  const { items } = useSliderState();

  return (
    <div className="bg-white md:flex overflow-hidden rounded shadow-lg">
      <Component items={items} />
    </div>
  );
};

export default SliderItem;
